import { Reveal } from "@/components/motion";

const STEPS = [
  {
    n: "01",
    title: "Unzip the archive",
    body: "Extract CNCroutersoft-1.0.0-win64.zip anywhere you like — Desktop, Documents, or a dedicated CNC folder. No installer, no registry writes.",
  },
  {
    n: "02",
    title: "Pin ShapeEditor",
    body: "Right-click ShapeEditor.exe → Send to → Desktop (create shortcut). Launch from the shortcut; the app finds shapelib next to the exe.",
  },
  {
    n: "03",
    title: "Keep shapes in shapelib",
    body: "Save every design into the shapelib folder inside the unzipped directory. ShapeEditor scans it on launch — anything elsewhere won't load.",
  },
];

export const Setup = () => (
  <section id="setup" className="px-6 sm:px-12 lg:px-20 py-24 max-w-[1400px] mx-auto" data-testid="setup">
    <Reveal>
      <p className="label-mono mb-4 flex items-center gap-3">
        <span className="inline-block w-8 h-px bg-[#FF3B00]" /> 03 — First run
      </p>
      <h2 className="font-display font-bold uppercase tracking-tight text-4xl sm:text-5xl leading-[0.95]">
        Three steps to first chips
      </h2>
    </Reveal>

    <div className="mt-14 grid md:grid-cols-3 gap-4">
      {STEPS.map((s, i) => (
        <Reveal key={s.n} delay={i * 0.12}>
          <div className="grid-cell p-8 sm:p-10 h-full group hover:border-[#FF3B00]/50 transition-colors duration-300" data-testid={`setup-step-${s.n}`}>
            <span className="font-display font-bold text-6xl text-stroke group-hover:text-[#FF3B00] group-hover:[-webkit-text-stroke:0px] transition-all duration-300">
              {s.n}
            </span>
            <h3 className="font-display uppercase tracking-tight text-2xl mt-6 mb-4">{s.title}</h3>
            <p className="text-white/70 text-sm leading-relaxed">{s.body}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
